const validate = values => {
  let errors = {};
  if (typeof values.firstName === 'undefined') {
    const firstNameError = { firstName: 'Field is required' };
    errors = Object.assign(errors, firstNameError);
  }
  return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./src/app/components/forms/validate/validate.js